import { render, staticRenderFns } from "./bubble-diagram-configuration.vue?vue&type=template&id=3845e0a1&scoped=true"
import script from "./bubble-diagram-configuration.ts?vue&type=script&lang=js&external"
export * from "./bubble-diagram-configuration.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3845e0a1",
  null
  
)

export default component.exports